module.exports = __webpack_public_path__ + "img/recv_mob_dia.png";